import { BookingFlowProvider } from "@/features/private-room/bookings/context/use-booking-flow";
import { BookingFlow } from "@/features/private-room/bookings/layouts/booking-flow";

export const BookingCreate = () => {
  return (
    <BookingFlowProvider>
      <BookingFlow />
    </BookingFlowProvider>
  );
};
